















import Vue, { PropType } from 'vue';
import { Icon } from '@descomplica/vue-components';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    images: {
      type: Array as PropType<String[]>,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    currentImg() {
      return this.images[(this as any).currentCount];
    },
    currentCount() {
      return Math.abs(this.$data.currentIndex) % this.images.length;
    },
  },
  methods: {
    next() {
      this.$data.currentIndex++;
    },
    prev() {
      this.$data.currentIndex--;
    },
  },
});
